import React from 'react';
import PropTypes from 'prop-types';
import { DatePicker } from 'material-ui-pickers';

import Input from '@material-ui/core/Input';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import Switch from '@material-ui/core/Switch';
import Menu from '@material-ui/core/Menu';
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';

import AddCircleIcon from '@material-ui/icons/AddCircle';
import MoreVertIcon from '@material-ui/icons/MoreVert';

import Select from '../../_Shared/SearchableDropdown';

const _ = require('lodash');
const styles = theme => ({
    head: {
        height: 50
    }
});
const moment = require('moment');

class EditableDataTable extends React.Component {

    constructor(props) {
        super(props);
        
        this.state = {
            rows: props.rows
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const { rows } = this.props;
        if (rows !== null && !_.isEqual(prevProps.rows, rows)) {
            this.setState({ rows });
        }
    }

    toggleRowMenu = (event, el) => {
        const { onElementSelect, toggleRowMenu, onCloseToggleRowMenu } = this.props;
        const { currentTarget } = event;

        if (el !== null && el !== undefined) {
            onElementSelect(el);
        }

        toggleRowMenu(currentTarget);

        if (el === null || el === undefined) {
            onCloseToggleRowMenu();
        }
    }

    executeAction = () => {
        this.props.onActionClick();
    }

    setRowChanges = (row, name, value, rowIndex) => {
        this.props.onEdit(Object.assign({}, row, { [name]: value }), rowIndex);
    }

    filterList = (rowIndex) => {
        const { onFilterList } = this.props;
        return onFilterList(rowIndex);
    }

    render() {
        const { columns, toggleRowMenu, children, anchorEl, action, classes } = this.props;
        const { rows } = this.state;
        return (
            <React.Fragment>
                <Table>
                    <TableHead>
                        <TableRow classes={{ head: classes.head }}>
                            {
                                [].concat(columns).map((col, colIndex) => <TableCell key={`table_header_cell_${colIndex}`}>{col.label}</TableCell>)
                            }
                            {
                                toggleRowMenu && !action && <TableCell numeric>Actions</TableCell>
                            }
                            {
                                toggleRowMenu && action &&
                                <TableCell numeric>
                                    <IconButton aria-label="Options" onClick={event => this.executeAction()}>
                                        <AddCircleIcon color="secondary" />
                                    </IconButton>
                                </TableCell>
                            }
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            [].concat(rows).map((el, rowIndex) => {
                                return (
                                    rows &&
                                    <TableRow key={`table_row_${rowIndex}`}>
                                        {
                                            [].concat(columns).map((col, colIndex) =>
                                                <TableCell key={`table_row_${rowIndex}_cell_${colIndex}`}>
                                                    {(() => {
                                                        switch (col.type) {
                                                            case 'number':
                                                                return <Input value={el[col.field]} onChange={e => this.setRowChanges(el, col.field, e.target.value, rowIndex)}
                                                                    id={col.field} name={col.field} type="number" />
                                                            case 'datetime':
                                                                return <DatePicker autoOk id={col.field} name={col.field} value={el[col.field]} format="DD/MM/YYYY"
                                                                    onChange={value => this.setRowChanges(el, col.field, value, rowIndex)} animateYearScrolling={false} />
                                                            case 'select':
                                                                return <Select options={[].concat(col.options).map(x => { return { 'label': x.name, 'value': x.id } })}
                                                                    value={el[col.field]} name={col.field} onChange={value => this.setRowChanges(el, col.field, value, rowIndex)}
                                                                    placeholder={col.placeholder} />
                                                            case 'select-flight':
                                                                return <Select options={[].concat(col.options).map(x => { return { 'label': moment(x.startDate).format('DD/MM/YYYY') + ' - ' + moment(x.endDate).format('DD/MM/YYYY'), 'value': x.id } })}
                                                                    value={el[col.field]} name={col.field} onChange={value => this.setRowChanges(el, col.field, value, rowIndex)}
                                                                    placeholder={col.placeholder} />
                                                            case 'select-external-field':
                                                                const selected = this.filterList(rowIndex);
                                                                return <Select options={[].concat(selected.externalFields).map(x => { return { 'label': x, 'value': x } })}
                                                                    value={el[col.field]} name={col.field} onChange={value => this.setRowChanges(el, col.field, value, rowIndex)}
                                                                    placeholder={col.placeholder} />
                                                            case 'toggle':
                                                                return <Switch
                                                                    checked={el[col.field]}
                                                                    onChange={e => this.setRowChanges(el, col.field, e.target.checked, rowIndex)}
                                                                    // value={el[col.field]}
                                                                />
                                                            default:
                                                                return <Input value={el[col.field]} onChange={e => this.setRowChanges(el, col.field, e.target.value, rowIndex)}
                                                                    id={col.field} name={col.field} type="text" fullWidth={col.fullWidth} disabled={col.disabled} />
                                                        }
                                                    })()}
                                                </TableCell>
                                            )
                                        }
                                        {
                                            toggleRowMenu &&
                                            <TableCell numeric>
                                                <Tooltip title="Options">
                                                    <IconButton aria-label="Options" onClick={event => this.toggleRowMenu(event, el)}>
                                                        <MoreVertIcon />
                                                    </IconButton>
                                                </Tooltip>
                                            </TableCell>
                                        }
                                    </TableRow>
                                );
                            })
                        }
                    </TableBody>
                </Table>
                <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={event => this.toggleRowMenu(event, null)} >
                    {children}
                </Menu>
            </React.Fragment>
        );
    }
}

EditableDataTable.propTypes = {
    classes: PropTypes.object.isRequired,
    columns: PropTypes.array.isRequired,
    rows: PropTypes.array.isRequired,
}

export default withStyles(styles, { withTheme: true })(EditableDataTable);


// WEBPACK FOOTER //
// ./src/Components/Presentation/_Shared/DataTables/EditableDataTable.js